import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { prop, define } from "@/components/builder/utils";

import { FormConsentInputBlock, FormConsentLabelBlock, FormConsentInstructionsContainerBlock, FormConsentInstructionsInputBlock, FormConsentInstructionsTextBlock, FormFeedbackMessageBlock } from "../../..";
import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

import { useStatus } from "./instructions/hook";

function FormConsentPreview({ ...props }) {
  const { field: { field_component } } = useFormFieldContext()
  const { status } = useStatus()

  if (field_component === 'checkbox_instructions_text') {
    return <BasePreview {...props}>
      <div data-status={status}>
        <Element is={FormConsentInstructionsContainerBlock} id={`consent-instructions-container`}>
          <Element is={FormConsentInstructionsInputBlock} id={`consent-instructions-input`} />
          <Element is={FormConsentInstructionsTextBlock} id={`consent-instructions-text`} />
          <Element is={FormFeedbackMessageBlock} id={`consent-instructions-feedback-message`} properties={{ customClassName: ['basis-full'], "customClassName-options": [{ label: 'basis-full', value: 'basis-full' }], fontSize: 'xs', fontWeight: 'font-light', textColor: 'red-400' }} />
        </Element>
        <Element is={FormConsentLabelBlock} id={`consent-instructions-label`} custom={{ utilities: ['[[data-status=checked]_&]', '[[data-status=error]_&]'] }} />
      </div>
    </BasePreview>
  }

  return <BasePreview {...props}>
    <div>
      {field_component !== 'text' && <Element is={FormConsentInputBlock} id={`consent-input`} />}
      <Element is={FormConsentLabelBlock} id={`consent-label`} />
    </div>
  </BasePreview>
}

export default define('form-consent', FormConsentPreview, Fragment)
  .shared(prop.share('FormConsent', 'form-consent'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

